(function(){
  var COPY='Dispatch within 2 calendar days';

  function addNote(container,key,before){
    if(!container||container.querySelector('[data-bx-dispatch-note="'+key+'"]'))return;
    var note=document.createElement('p');
    note.className='bx-cart-dispatch-note';
    note.setAttribute('data-bx-dispatch-note',key);
    note.innerHTML='<span class="bx-cart-dispatch-note__dot" aria-hidden="true">●</span>'+COPY;
    if(before&&before.parentNode===container)container.insertBefore(note,before);
    else container.appendChild(note);
  }

  function sync(){
    document.querySelectorAll('.drawer__footer').forEach(function(footer){
      addNote(footer,'drawer',footer.querySelector('.cart__ctas'));
    });
    document.querySelectorAll('.cart-notification__links').forEach(function(links){
      addNote(links,'notification',links.firstElementChild);
    });
    document.querySelectorAll('main[data-template="cart"] .cart__blocks').forEach(function(blocks){
      addNote(blocks,'page',blocks.querySelector('.cart__ctas'));
    });
  }

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',sync);
  else sync();

  document.addEventListener('shopify:section:load',sync);
  document.addEventListener('cart:updated',sync);
  document.addEventListener('change',function(event){
    if(event.target.closest('cart-items,cart-drawer-items'))setTimeout(sync,450);
  });

  var observer=new MutationObserver(function(){sync();});
  observer.observe(document.documentElement,{childList:true,subtree:true});
})();
